import { fetchAPI } from "../../../../../config/axios";
import { HasilEvaluasiAction, HasilEvaluasiActionType, HasilEvaluasiDataModel } from "./types";

export const HasilEvaluasiMain: HasilEvaluasiDataModel = {
  main: {
    data: [],
    total: 0,
  },
};

export const HasilEvaluasiReducer = (
  state: HasilEvaluasiDataModel = HasilEvaluasiMain,
  action: HasilEvaluasiAction
): HasilEvaluasiDataModel => {
  switch (action.type) {
    case HasilEvaluasiActionType.GetHasilEvaluasi:
      return { ...state, main: action.data };
    default:
      return state;
  }
};

export const HasilEvaluasiCommand = {
  GetHasilEvaluasi: (params: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().get(
          "/tj-parameter-penilaian/hasil-evaluasis",
          { params }
        );
        dispatch({
          type: HasilEvaluasiActionType.GetHasilEvaluasi,
          data: {
            data: response.data.data.data,
            total: response.data.data.total,
          },
        });
      } catch (error) {
        throw error;
      }
    };
  },
  CreateHasilEvaluasi: (body: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().post(
          "/tj-parameter-penilaian/hasil-evaluasi",
          body
        );
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
  UpdateHasilEvaluasi: (body: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().patch(
          "/tj-parameter-penilaian/hasil-evaluasi",
          body
        );
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
  DeleteHasilEvaluasi: (params: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().delete(
          "/tj-parameter-penilaian/hasil-evaluasi",
          { params }
        );
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
};
